import { render, staticRenderFns } from "./McpStickyBanner.vue?vue&type=template&id=3457af58&scoped=true&"
import script from "./McpStickyBanner.vue?vue&type=script&lang=js&"
export * from "./McpStickyBanner.vue?vue&type=script&lang=js&"
import style0 from "./McpStickyBanner.vue?vue&type=style&index=0&id=3457af58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3457af58",
  null
  
)

export default component.exports